<div class="dialog-title">Role and Permission</div>
<div style="display: flex; flex-direction: column" class="gap-8px">
  <div class="body-regular">Role Name<span style="color: red">*</span></div>
  <div class="role-name-holder">{{ roleName }}</div>
</div>

<div style="display: flex; flex-direction: column" class="gap-8px">
  <div class="title-text">Permission</div>
  <div class="sub-title">Access rights will be granted according to the user level.</div>
</div>

<!-- Desktop View -->
<div class="menu-holder desktop-view" *ngFor="let menuName of menuOrder | async">
  <div style="align-items: center; display: flex; gap: 8px" class="title-text menu-title">
    <div>
      {{ menuName | titlecase }}
    </div>
  </div>
  <div class="permission-holder">
    <ng-container *ngIf="permissionMap | async as result">
      <div *ngFor="let permission of result[menuName]">
        <lib-checkbox [(ngModel)]="checked" [label]="permission" [disabled]="true" />
      </div>
    </ng-container>
  </div>
</div>

<!-- Mobile Tree View -->
<div class="mobile-tree-view" *ngFor="let menuName of menuOrder | async">
  <div class="tree-menu-header" (click)="toggleTreeMenu(menuName)">
    <div class="tree-menu-title">{{ menuName | titlecase }}</div>
    <i class="pi" [ngClass]="isTreeMenuOpen(menuName) ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
  </div>
  <div class="tree-permission-list" *ngIf="isTreeMenuOpen(menuName)">
    <ng-container *ngIf="permissionMap | async as result">
      <div *ngFor="let permission of result[menuName]" class="tree-permission-item">
        <div class="green-check-circle">
          <i class="pi pi-check"></i>
        </div>
        <span class="tree-permission-text">{{ permission }}</span>
      </div>
    </ng-container>
  </div>
</div>

<div style="width: 1/3" class="button-group">
  <lib-button (click)="onClose()" type="Secondary" label="Close"></lib-button>

  <a
    [userAccess]="'roles-and-permissions.edit'"
    *ngIf="isDefaultRole"
    [href]="'setting/roles/edit/' + uuid"
  >
    <lib-button type="Primary" label="Edit"></lib-button>
  </a>
</div>
